module.exports = __webpack_public_path__ + "ea3c4697897bd7f1505facb7084c6ac3.svg";